import api from '.';
import { buildParams } from '../helpers/tableUtil';
import { FILTERS, SortDirection } from '../models/global';

class OrganizationSurvey {
  static async getOrganizationSurvey({ id, organizationId }: { id: string; organizationId: string }) {
    const survey = await api.get(`/organization-survey/${id}${organizationId ? `/${organizationId}` : ''}`);
    return survey.data;
  }

  static async createOrganizationSurveyAnswers(id: string, data) {
    delete data.id;
    const survey = await api.post(`/organization-survey/${id}`, data);
    return survey.data;
  }

  static async handleSurveyLock(id: string, data) {
    delete data.id;
    const survey = await api.put(`/organization-survey/${id}`, data);
    return survey.data;
  }

  static async submitSurvey(id: string) {
    const survey = await api.put(`/organization-survey/submit/${id}`);
    return survey.data;
  }

  static async getOrganizationSurveys({
    limit,
    page,
    filters,
    orderData,
  }: {
    limit?: number;
    page: number;
    filters: FILTERS[];
    orderData?: {
      orderBy: string;
      sortDirection: SortDirection;
    };
  }) {
    const params = buildParams({ limit, page, orderData });
    const survey = await api.post(`/organization-survey${params}`, filters);
    return survey.data;
  }
}

export default OrganizationSurvey;
